import { createSlice } from "@reduxjs/toolkit";

export const uiSlice = createSlice({
  name: "ui",
  initialState: {
    bottomBarExpanded: false,
    popover: null,
    subTab: 0,
    previousPopover: null,
    previewMode: false,
    userApiCalled: false,
    fontsApiCalled: false,
    generateMode: false,
    generateVideoWarningMessage: "",
    audioSubTab: 0,
  },
  reducers: {
    toggleBottomBar: (state, action) => {
      state.bottomBarExpanded = action.payload ?? !state.bottomBarExpanded;
    },
    openPopover: (state, action) => {
      if (state.previousPopover !== state.popover) {
        state.subTab = 0;
        state.previousPopover = action.payload;
      }
      state.popover = action.payload;
    },
    closePopover: (state) => {
      state.subTab = 0;
      state.popover = null;
    },
    setPreviewMode: (state, action) => {
      state.previewMode = action.payload;
    },
    setGenerateMode: (state, action) => {
      state.generateMode = action.payload;
    },
    selectSubTab: (state, action) => {
      if (action && action.payload) state.subTab = action.payload;
      else state.subTab = 0;
    },
    setUserApiCalled: (state, action) => {
      state.userApiCalled = action.payload;
    },
    setFontsApiCalled: (state, action) => {
      state.fontsApiCalled = action.payload;
    },
    setVideoGenerateWarningMessage: (state, action) => {
      state.generateVideoWarningMessage = action.payload;
    },
    setAudioSubTab: (state, action) => {
      state.audioSubTab = action.payload;
    },
  },
});

export const {
  toggleBottomBar,
  openPopover,
  closePopover,
  selectSubTab,
  setPreviewMode,
  setUserApiCalled,
  setFontsApiCalled,
  setGenerateMode,
  setVideoGenerateWarningMessage,
  setAudioSubTab,
} = uiSlice.actions;

export default uiSlice.reducer;
